import { useEffect, useState } from 'react';
import { getImageUrl } from 'lib/getImageUrl';

const useImageFetcher = (imgArray, onlyFirst = false) => {
  const [imageUrls, setImageUrls] = useState(['/kin/assest/image/icon-profile.png']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Gunakan JSON.stringify agar dependency stabil jika isinya sama
  const imgArrayString = JSON.stringify(imgArray);

  useEffect(() => {
    const fetchImages = async () => {
      // Parsing kembali string array-nya
      const currentImages = JSON.parse(imgArrayString);

      if (!Array.isArray(currentImages) || currentImages.length === 0) {
        setImageUrls(['/kin/assest/image/icon-profile.png']);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const targetImages = onlyFirst ? [currentImages[0]] : currentImages;

        const urls = await Promise.all(targetImages.map((img) => getImageUrl(img)));
        setImageUrls(urls);
      } catch (err) {
        console.error('Error fetching images:', err);
        setError(err);
        setImageUrls(['/kin/assest/image/icon-profile.png']);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [imgArrayString, onlyFirst]);

  return { imageUrls, loading, error };
};

export default useImageFetcher;
